export interface OperatorsState {
    operatorsData: any;
    loading: boolean;
    error: null | string;
}


export enum OperatorsActionTypes {
    FETCH_OPERATORS_DATA = "FETCH_OPERATORS_DATA",
    FETCH_OPERATORS_DATA_SUCCESS = "FETCH_OPERATORS_DATA_SUCCESS",
    FETCH_OPERATORS_DATA_ERROR = "FETCH_OPERATORS_DATA_ERROR",
}

export type OperatorsAction =
    | { type: OperatorsActionTypes.FETCH_OPERATORS_DATA }
    | { type: OperatorsActionTypes.FETCH_OPERATORS_DATA_SUCCESS; payload: any[] }
    | { type: OperatorsActionTypes.FETCH_OPERATORS_DATA_ERROR; payload: string };

